// web/src/components/browser/EmptyState.tsx
export function EmptyState({ folderPath }: { folderPath: string }) {
  return (
    <div className="flex h-full min-h-[50vh] flex-col items-center justify-center gap-3 px-10 text-center text-text-soft">
      <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-accent-bg text-2xl text-accent-soft">
        ＋
      </div>
      <h2 className="text-lg font-medium text-text">
        This folder is empty.
      </h2>
      <p className="max-w-sm text-sm leading-relaxed">
        Drop files here to add them to{" "}
        <span className="font-mono text-text">{folderPath || "/"}</span>.
        Everything is encrypted on this device before it touches storage —
        the bucket you chose never sees plaintext.
      </p>
      <div className="mt-2 rounded-lg border border-dashed border-accent-soft px-7 py-4 text-xs text-accent-soft">
        ↓  Drag files here to upload
      </div>
    </div>
  );
}
